import { useState, useEffect } from 'react';
import './App.css';
import FormulariosJornadas from './components/FormulariosJornadas';
import AdminFormularios from './components/AdminFormularios';
import InscripcionesTable from './components/InscripcionesTable';

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminPassword, setAdminPassword] = useState('');
  const [adminPasswordInput, setAdminPasswordInput] = useState('');
  const [adminView, setAdminView] = useState('config');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('admin')) {
      setIsAdmin(true);
      const passFromUrl = urlParams.get('admin');
      if (passFromUrl && passFromUrl === 'MF1234') {
        setAdminPassword('MF1234');
      }
    }
  }, []);

  const handleAdminAuth = () => {
    if (adminPasswordInput === 'MF1234') {
      setAdminPassword('MF1234');
      setAdminPasswordInput('');
    } else {
      alert('Contraseña incorrecta');
      setAdminPasswordInput('');
    }
  };

  if (isAdmin && !adminPassword) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-white">
        <link href="https://fonts.googleapis.com/css2?family=Oswald:wght@600;700&family=Teko:wght@500;700&display=swap" rel="stylesheet" />
        <style>{`
          .f-oswald { font-family: 'Oswald', sans-serif !important; }
          .f-teko { font-family: 'Teko', sans-serif !important; }
          .text-red-imp { color: #e30613 !important; }
        `}</style>
        <div className="border-t-8 border-red-600 bg-white p-8 shadow-2xl max-w-md w-full mx-4">
          <h2 className="f-oswald text-3xl font-bold uppercase mb-6 text-black">Acceso Admin</h2>
          <input
            type="password"
            value={adminPasswordInput}
            onChange={(e) => setAdminPasswordInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleAdminAuth()}
            placeholder="Contraseña"
            className="w-full border-2 p-3 mb-4 f-oswald uppercase text-black"
          />
          <button
            onClick={handleAdminAuth}
            className="w-full bg-black text-white py-3 f-oswald uppercase font-bold hover:bg-red-600 transition-all"
          >
            Entrar
          </button>
        </div>
      </div>
    );
  }

  if (isAdmin && adminPassword) {
    return (
      <div className="w-full font-sans text-black pb-10 overflow-hidden bg-white">
        <link href="https://fonts.googleapis.com/css2?family=Oswald:wght@600;700&family=Teko:wght@500;700&display=swap" rel="stylesheet" />
        <style>{`
          .f-oswald { font-family: 'Oswald', sans-serif !important; }
          .f-teko { font-family: 'Teko', sans-serif !important; }
          .text-black-imp { color: #000000 !important; }
          .text-red-imp { color: #e30613 !important; }
        `}</style>

        <div className="max-w-7xl mx-auto px-4">
          <div className="flex gap-4 mb-8 mt-8">
            <button
              onClick={() => setAdminView('config')}
              className={`px-6 py-3 f-oswald uppercase font-bold transition-all ${
                adminView === 'config'
                  ? 'bg-black text-white'
                  : 'bg-zinc-100 text-black hover:bg-black hover:text-white'
              }`}
            >
              Configurar Campos
            </button>
            <button
              onClick={() => setAdminView('inscritos')}
              className={`px-6 py-3 f-oswald uppercase font-bold transition-all ${
                adminView === 'inscritos'
                  ? 'bg-black text-white'
                  : 'bg-zinc-100 text-black hover:bg-black hover:text-white'
              }`}
            >
              Ver Inscritos
            </button>
            <button
              onClick={() => {
                setAdminPassword('');
                setIsAdmin(false);
              }}
              className="ml-auto px-6 py-3 f-oswald uppercase font-bold bg-red-600 text-white hover:bg-red-700 transition-all"
            >
              Salir
            </button>
          </div>

          {adminView === 'config' && <AdminFormularios />}
          {adminView === 'inscritos' && <InscripcionesTable />}
        </div>
      </div>
    );
  }

  return <FormulariosJornadas />;
}

export default App;
